export default {
  en: {
    'components.header.logout': 'Logout',
  },
};
